import '../header.css'
import { Link } from 'react-router-dom'
import { useState } from 'react'

const UserDropDown = () => {
    const [toggle, setToggle] = useState(false)
    return (
        <div className="header-pic user-pic">
            <img
                onClick={() => setToggle(prev => !prev)} src="https://templates.hibotheme.com/bixu/default/assets/images/team/team-img-2.png" alt="" />
            {toggle && <ul className='user-dropdown'>
                <li>
                    <Link><i className="fa-solid fa-home"></i> <span>Home</span></Link>
                </li>
                <li>
                    <Link><i className="fa-solid fa-user"></i> <span>Logout</span></Link>
                </li>
            </ul>}
        </div>
    )
}

export default UserDropDown